import { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import PeopleIcon from '@mui/icons-material/People';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './User.css';

const UserEdit = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({
        FirstName: '', LastName: '', UserName: '', Email: '', ContactNumber: '',
    });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, token]);

    useEffect(() => {
        fetchData('UserApi', `/UserDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') setFormData(response.response_data);
            })
            .catch((e) => console.error('Error fetching User Details:', e));
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => {
            const updated = { ...prev, [name]: value };
            if (name === 'FirstName' || name === 'LastName') {
                const generated = `${updated.FirstName.toLowerCase()}_${updated.LastName.toLowerCase()}`;
                updated.UserName = generated.slice(0, 15);
            }
            return updated;
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!formData.FirstName) { setErrorMessage('First Name is required!'); return; }
        if (!formData.LastName) { setErrorMessage('Last Name is required!'); return; }
        updateData('UserApi', `${id}`, { ...formData, UpdatedBy: userId }, token)
            .then(() => history.push('/UserIndex'))
            .catch((e) => { console.error('Error updating record:', e); setErrorMessage('Error updating user.'); });
    };

    return (
        <div className="user-container">
            <div className="user-header-card">
                <div className="user-header-content">
                    <div className="user-title-section">
                        <span className="user-title-icon"><PeopleIcon fontSize="small" /></span>
                        <h1 className="user-title">User Edit</h1>
                    </div>
                    <div className="user-header-actions">
                        <button className="usr-btn usr-btn-create" onClick={handleSubmit}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Update
                        </button>
                        <Link to="/UserIndex" className="usr-btn usr-btn-cancel">
                            <ArrowBackIcon style={{ fontSize: 14 }} />&nbsp;Cancel
                        </Link>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="user-alert user-alert-error">{errorMessage}</div>}
            {successMessage && <div className="user-alert user-alert-success">{successMessage}</div>}

            <div className="user-form-card">
                <p className="user-form-section-title">User Information</p>
                <div className="user-form-row">
                    <div className="user-form-group">
                        <label className="user-label">First Name <span className="required">*</span></label>
                        <input className="user-input" type="text" name="FirstName" value={formData.FirstName} onChange={handleChange} placeholder="Enter first name" maxLength={30} />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">Last Name <span className="required">*</span></label>
                        <input className="user-input" type="text" name="LastName" value={formData.LastName} onChange={handleChange} placeholder="Enter last name" maxLength={30} />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">User Name</label>
                        <input className="user-input" type="text" name="UserName" value={formData.UserName} readOnly placeholder="Auto-generated" />
                    </div>
                </div>
                <div className="user-form-row">
                    <div className="user-form-group">
                        <label className="user-label">Contact Number <span className="required">*</span></label>
                        <input className="user-input" type="text" name="ContactNumber" value={formData.ContactNumber} onChange={handleChange} placeholder="Enter contact number" maxLength={15} />
                    </div>
                    <div className="user-form-group">
                        <label className="user-label">Email <span className="required">*</span></label>
                        <input className="user-input" type="text" name="Email" value={formData.Email} onChange={handleChange} placeholder="Enter email" maxLength={40} />
                    </div>
                    <div className="user-form-group" />
                </div>
            </div>
        </div>
    );
};

export default UserEdit;
